export default {
  // Mode
  "common.mode.auto": "Self-consumption",
  "common.mode.economy": "Economy Mode",
  "common.mode.exigency": "Emergency Mode",

  // Device
  "common.grid": "Grid",
  'common.evChargers': 'EV Chargers',
  'common.evCharger': 'EV Charger',
  'common.pv': 'PV',
  'common.inverter': 'Inverter',
  'common.pcs': 'Inverter + Battery',
  'common.terminal': 'Terminal Device',
  'common.airc': 'Air Conditioner',
  'common.engine': 'Engine',
  'common.battery': 'Battery',
  'common.metter': 'Meter',
  'common.other': 'Other',
  "common.power": "Power",
  "common.powerTotal": "Total Power",
  "common.voltage": "Voltage",
  "common.electricity": "Electricity",
  "common.current": "Current",
  "common.homeUsage": "Home Total Load",
  "common.battery.power": "Battery power",

  // Data
  "common.noDataAvailable": 'No data available~',
  'common.tips': 'Tips',
  "common.reset": "Reset",
  "common.currencyUnit": '¥',
  "common.submiting": 'Submitting, please wait...',
  "common.close": 'Close',
  "common.from": 'From',
  "common.useIn": 'Used for',
  "common.energyPercent": 'Energy Flow Ratio',
  "common.dataFlow": "Data Flow",
  "common.getDataIng": 'Getting data, please wait...',
  "common.pageLoading": 'Page is loading, please wait...',
  "common.reseting": "Page is resetting, please wait...",
  "common.save": 'Save',
  "common.onlyNumberTips": "Only numbers allowed",
  "common.offline": "Offline",
  "common.online": "Online",
  "common.fault":"Fault",
  "common.charge": "Charge",
  "common.discharge": "Discharge",
  "common.buy": "Buy",
  "common.sell": "Sell",
  "common.loadingInfo": 'Loading, please wait...',

  // 
  "common.moreFeatures": "More Features",
  "common.confirm": 'Confirm',
  "common.saveing": "Saving, please wait...",
  "common.searchPlacholder": "Please enter search keywords",
  "common.iSee": 'I got it',
  "common.pageErrorTips1": "Oops, page error~",
  "common.pageErrorTips2": "Please try refreshing or contact customer service~",
  "common.refresh": "Refresh",
  "common.backToHome": "Back to Home",
  "common.checkTips": "Verifying, please wait...",
  "common.back": "Back",
  "common.cancel": "Cancel",
  "common.optional": "Optional",
  "common.required": "Required",
  "common.status": "Status",
  "common.statusNoDelete": "Not Deleted",
  "common.statusDelete": "Deleted",
  "common.submit": 'Submit',
  "common.disable": "Disable",
  "common.enable": "Enable",
  "common.year": 'Year',
  "common.month": 'Month',
  "common.day": 'Day',
  "common.version": 'Version: ',
  "common.backHome": ' Back to Home',
  "common.backHomeSorry": ' Sorry, the page got lost',
  "common.requestTips1": 'Data is processing, please do not submit again',
  "common.requestTips2": "System Notice",
  "common.requestTips3": "Login session expired, please login again",
  "common.requestTips4": "Login Again",
  "common.requestTips5": "Invalid session or session expired, please login again.",
  "common.requestTips6": "Server error, please try again later.",
  "common.requestTips7": "System interface request timeout",
  "common.requestTips8": 'System Interface',
  "common.requestTips9": 'Error',
  "common.iknow": 'I got it',
  "common.logoutSuccess": "Logout successful",
  
  // Know More component
  "common.knowMore.title": 'Want to know more? Please contact Beineng',
  "common.knowMore.email": 'Contact Email',
  "common.knowMore.phone": 'Contact Phone',
  "common.knowMore.wechat": 'Contact WeChat',
  "common.knowMore.website": 'Official Website',
  "common.knowMore.address": 'Contact Address',
  "common.knowMore.addressDetail": '153-1 Tianhe East Road (330 Meters Walk From The Entrance And Exit Of Shipaiqiao Metro Station), Guode Building',
  
  // Local Connection component
  "common.localConnection": 'Local Connection',
  "common.operateInApp": 'Please operate in the APP!',
  
  "common.enbleStaus": "Enable Status",
  "common.battery.status": "Neither charging nor discharging",

  'account.forgetThePassword': 'Forgot Password',
    'account.logInDirectly': 'Go to Login',
    'account.tips1': 'Page is redirecting, please wait...',
    'account.tips2': 'Please review and agree to the user terms first!',
    'account.autoLogin': 'Auto Login',
    'account.userLogin': 'User Login',
    'account.registerTips': "Don't have an account? Click here to register",
    'account.userEmail': 'Username/Email',
    'account.userEmailTips': 'Please enter username/email',
    'account.password': 'Password',
    'account.passwordTips': 'Please enter password',
    'account.submit': 'Submit',
    'account.submitTips': 'Submitting, please wait...',
    'account.otherLoginTips': 'Or choose other login methods',
    'account.userRegistration': 'User Registration',
    'account.userName': 'Username',
    'account.userNameTips': 'Please enter username',
    'account.emailTips1': 'Please enter email address',
    'account.emailTips2': 'Invalid email format',
    'account.phone': 'Phone Number',
    'account.phoneTips1': 'Please enter phone number',
    'account.phoneTips2': 'Invalid phone number',
    'account.phoneTips3': 'Please enter phone number',
    'account.passwordTips1': 'Please enter 6-30 characters password',
    'account.passwordTips2': 'Invalid password format. Password can contain letters, numbers, underscore, hyphen and dot, 6-12 characters',
    'account.passwordTips3': 'Passwords do not match, please check and re-enter!',
    'account.passwordTips4': 'Please enter password. Password can contain letters, numbers, underscore, hyphen and dot',
    'account.passwordTips5': 'Confirm Password',
    'account.passwordTips6': 'Please enter confirm password',
    'account.passwordTips7': 'Passwords do not match, please check and re-enter!',
    'account.passwordTips8': 'Please enter confirm password',
    'account.passwordTips9': 'Congratulations! Registration successful!',
    'account.passwordTips10': 'Your username is: ',
    'account.emailIs': 'Email is: ',
    'account.goToLoginPage': 's will auto redirect to login page',
    'account.goLogin': 'Go to Login',
    'account.goRegister': 'Register',
    'account.loginSuccess': 'Login Successful',
    'account.email': 'Email',
    'account.sologn': 'Creating your exclusive energy solution with care',
    'account.pleaseAgree': 'I have read and agree to',
    'userAgreement.privacyPolicy': 'Privacy Policy',

    "account.code": "Verification Code",
    "account.codeTips": "Please enter verification code",
    "account.codeTips2": "Incorrect verification code",
    "account.inviteCodeTips": "Please enter invite code",
    "account.inviteCodeHint": "Please contact installer or O&M personnel to obtain the invite code",

    "account.modifyPasswordByAccount": "Change Password by Account",
    "account.modifyPasswordByEmail": "Change Password by Email",
    "account.getPasswordByAccount": "Retrieve Password by Account",
    "account.getPasswordByEmail": "Retrieve Password by Email",

    "account.sendEmailTips": "Verification code has been sent to your email, please check",
    "account.name": "Account Name",
    "account.newPassword": "New Password",
    "account.confirmNewPassword": "Confirm New Password",
    "account.nameTips": "Please enter account name",
    "account.passwordModifySuccess": "Password changed successfully",
    "account.emailCode": "Email Verification Code",
    "account.emailCodeTips": "Please enter email verification code",
    "account.emailCodeTips2": "Incorrect email verification code",
    "account.emailModifySuccess": "Password modified successfully",
    "account.passworTips1": "Your password has been reset successfully!",
    "account.passwordTips11": "Please enter confirm password",
    "account.passwordTips12": "Please enter new password",
    "account.nickname": "Nickname",
    "account.modifyNickname": "Change Nickname",
    "account.modifyNicknameSuccess": "Nickname changed successfully!",
    "account.nicknameTips": "Please enter nickname",
    'account.nicknameError': 'Failed to change nickname!',

    "account.login": 'Login',
    'account.quickRegister': 'Quick Register',
    'account.sendCode': 'Send Code',
    'account.sendTips': 's to resend',
    "account.sendEmailIng": 'Sending email, please wait...',
    'account.emailNotEmpty': 'Email address cannot be empty',
    'account.registerAccount': 'Register Account',
    'account.registerWelcome': 'Welcome to SusprSafe',
    'account.usernameLimit': 'Username must start with a letter and can only contain letters, numbers, and underscores, 5-15 characters',

    'copyright.desc2': 'Website Registration: Guangdong ICP No. 2021169764',

    'editUserInfo.editUserInformation': 'Edit User Information',
    'editUserInfo.modifyUsername': 'Change Username',
    'editUserInfo.changePictures': 'Change Avatar',
    'editUserInfo.savePicturesSuccess': 'Avatar saved successfully',
    'editUserInfo.saveError': 'Save failed',
    'editUserInfo.pictureLimit':'Image must be less than 2MB',
    'editUserInfo.uploadPicture':'Upload Avatar',
    'editUserInfo.picturePreview':'Preview',
    
    'editUserInfo.bindPhoneNumber': 'Bind Phone Number',
    'editUserInfo.bindEmail': 'Bind Email',
    'editUserInfo.changePassword': 'Change Password',

    'editUserInfo.notificationSettings': 'Notification Settings',
    'editUserInfo.editAccount': 'Edit Account Information',
    'editUserInfo.waitBingting': 'Binding, please wait...',
    'editUserInfo.collapse': 'Collapse',
    'editUserInfo.modifyBinding': 'Modify Binding',
    
    'editUserInfo.emailAddress': 'Email Address',
    'editUserInfo.tips1': 'Email bound successfully',
    'editUserInfo.tips2': 'Save failed',
    'editUserInfo.tips3': 'Sending email verification code, please wait...',
    'editUserInfo.tips4': 'Verification code has been sent to email xxxx, please check',
    'editUserInfo.tips5': 'Failed to send verification code!',
    'editUserInfo.tips6': 'Phone number already bound',
    'editUserInfo.tips7': 'Email already bound',
    'editUserInfo.emailTips1': 'Please enter email address',
    'editUserInfo.emailTips2': 'Invalid email format',
    'editUserInfo.emailTips3': 'Can resend after xxxxs',
    'editUserInfo.emailTips4': 'Send Code',
    'editUserInfo.emailTips5': 'Email verification code cannot be empty',
    'editUserInfo.emailTips6': 'Incorrect email verification code',
    'editUserInfo.emailCode': 'Email Verification Code',
    'editUserInfo.save': 'Save',

    'editUserInfo.phoneTips1': 'Phone number bound successfully',
    'editUserInfo.phoneTips2': 'Sending SMS verification code, please wait...',
    'editUserInfo.phoneTips3': 'SMS verification code has been sent to phone xxxx, please check',
    'editUserInfo.phoneTips4': 'Failed to send SMS verification code!',
    'editUserInfo.phoneTips5': 'Please enter phone number',
    'editUserInfo.phoneTips6': 'Invalid phone number format',
    'editUserInfo.phoneTips7': 'Send SMS Code',
    'editUserInfo.phoneTips8': 'SMS Verification Code',
    'editUserInfo.phoneTips9': 'Phone verification code cannot be empty',
    'editUserInfo.phoneTips10': 'Incorrect phone verification code',
    'editUserInfo.phone': 'Phone Number',


    'editUserInfo.noticeTips1': 'Failed to get notification settings!',
    'editUserInfo.noticeTips2': 'Notification settings saved successfully!',
    'editUserInfo.noticeTips3': 'Low Battery Notification',
    'editUserInfo.noticeTips4': 'Charging Complete Notification',
    'editUserInfo.errorNotification': 'Error Notification',
    'editUserInfo.updateNotification': 'Update Notification',
    'editUserInfo.monthlyStatisticsNotification': 'Monthly Statistics Notification',
    'editUserInfo.notificationMethod': 'Receive Method',

    'editUserInfo.userNameTips1': 'Username saved successfully',
    'editUserInfo.userNameTips2': 'Failed to save username',
    'editUserInfo.userNameTips3': 'Please enter username',
    'editUserInfo.userNameTips4': 'Invalid username format, must contain only letters, numbers and underscores',
    'editUserInfo.userNameTips5': 'Please enter username',
    'editUserInfo.userNameTips6': 'Saving, please wait...',
    'editUserInfo.userName': 'Username',

    'editUserInfo.avatorTips': 'Click to change avatar',
    'editUserInfo.verifyCodeTips1': 'Please enter the verification code you received:',
    'editUserInfo.verifyCodeTips2': 'For your account security, please click the button below to send verification code to your original phone number:',
    'editUserInfo.verifyCodeTips3': 'Send Code',
    'editUserInfo.verifyCodeTips4': 'Original phone verified, please enter new phone number to bind',
    'editUserInfo.verifyCodeTips5': 'For your account security, please click the button below to send verification code to your original email:',
    'editUserInfo.verifyCodeTips6': 'Original email verified, please enter new email',
    'editUserInfo.verifyCodeTips7': 'Old Password',
    'editUserInfo.verifyCodeTips8': 'Please bind email first!',
    'editUserInfo.verifyCodeTips9': 'Verification code has been sent to your email, please check',
    "editUserInfo.verifyCodeTips10": ', will auto redirect to login page',

    "hems.notice.title": "Notification Title", 
   "hems.notice.content": "Notification Content", 
   "hems.notice.operate": "Action",
   "hems.notice.noRead": "Unread",
   "hems.notice.read": "Read",
   "hems.notice.warning": "Reminder",
   "hems.notice.error": "Error",
   "hems.notice.success": "Statistics",
   "hems.notice.sys": "System Info",
   "hems.notice.operateSuccess": "Operation Successful",
   "hems.notice.operateTips": "Please select items to operate",

    // Home Page
   "hems.home.selfuseRate": "Self-consumption Rate",
   "hems.home.percent": "Percentage",
   "hems.home.todayData": "Today's Data",
   "hems.home.todayPowerGeneration": "Today's Power Generation",
   "hems.home.salesIncome": "Electricity Sales Revenue",
   "hems.home.saved": "Saved for You",
   "hems.home.reduce": "Carbon Footprint Reduced",
   "hems.home.tips1": "No data, you haven't bound xxxx yet",
   "hems.home.criticalLoad": "Critical Load",
   "hems.home.keyVoltage": "Critical Voltage",
   "hems.home.householdLoad": "Household Load",
   "hems.home.householdVoltage": "Household Voltage",
   "hems.home.generalLoad": "General Load",
   "hems.home.generalVoltage": "General Voltage",
   "hems.home.batteryHealth": "Battery Health",
   "hems.home.averageTemp": "Average Temperature",
   "hems.home.gridLoad": "Grid Load",
   "hems.home.toggeleDataSource": "Current display data switched to:",
   "hems.home.toggleTips": "Are you sure you want to switch?",
   "hems.home.modeSending": "Mode command is being sent, please wait...",
   "hems.home.modeSuccess": "Mode switch command sent successfully!",
   "hems.home.isOnline": "Online Status",
   "hems.home.useStatus": "Usage Status",
   "hems.home.workModeText": 'Current Working Mode: ',
   "hems.home.toggleDataSourceText": 'Current display data switched to: ',
   "hems.ev.charge.status": "Charging Status",
   "hems.ev.charge.time": "Charging Duration",
   "hems.ev.charge.count": "Real-time Charging Amount",
   "hems.ev.charge.status.empty":"Idle",
   "hems.ev.charge.status.ing":"Charging",
   "hems.ev.charge.status.null":"Plugged Not Charging",
   "hems.ev.charge.status.error":"Fault",
   "hems.hour":"Hours",
   "hems.minue":"Minutes",
   "hems.ev.chagre.number": "Charger Number",

   // User Guide
   "hems.userGuide.selfUse": "Self-consumption",
   "hems.userGuide.selfUseTips": "Prioritize using PV generation, supplement from grid when insufficient",
   "hems.userGuide.economyMode": "Economy Mode",
   "hems.userGuide.economyModeTips": "Optimize electricity usage strategy based on tariff",
   "hems.userGuide.emergencyMode": "Emergency Mode", 
   "hems.userGuide.emergencyModeTips": "Prioritize critical load power supply",

   // Chart Page
   "hems.history.energyStatistics": "Energy Statistics",
   "hems.history.revenueStatistics": "Revenue Statistics",
   "hems.history.greenStatistics": "Green Emissions Reduction",
   "hems.history.revenueTitle": "Total Electricity Sales Revenue",
   "hems.history.savingsTitle": "Total Savings",
   "hems.history.carbonTitle": "Total Carbon Emissions Reduced",
   "hems.history.day": "Day",
   "hems.history.month": "Month",
   "hems.history.year": "Year",
   "hems.history.beforeDay": "Previous Day",
   "hems.history.afterDay": "Next Day",
   "hems.history.beforeMonth": "Previous Month",
   "hems.history.afterMonth": "Next Month",
   "hems.history.beforeYear": "Previous Year",
   "hems.history.afterYear": "Next Year",
   "hems.history.totalUse": 'Total Usage',
   "hems.history.fullScreen": 'Full Screen',
   "hems.history.timeSelect": "Date Selection",
   "sync.tips1": "Data sync command sent successfully!",
   "sync.tips2":"Data sync in progress. Due to large data volume, the sync process will take some time. Please check back in half an hour~",
   "sync.tips3": "Device data sync may be delayed. If you find data anomalies, please click:",
   "sync.tips4": "Sync Data",

  "charge.info": "Charger Information",
  "news.loading": 'Loading...',
  "news.noMore": 'No more',
  "hems.pv.power": 'PV Power Supply',

  // UEH specific
  "ueh.sellPower": "Power Sold",
  
  "menu.home": "Home",
  "menu.history": "History",
  "menu.device": "Device",
  "menu.settings": "Settings",
  "menu.messageCenter": "Message Center",
  "menu.help": "Help & Support",
  "menu.mine": "Mine",


  "mine.userSetting": "User Settings",
  "mine.terminalSetting": "Terminal Basic Settings",
  "mine.uploadCloud": "Cloud Data Backup",
  "mine.changeVersion": "Check for Updates",
  "mine.language": "Change Language",
  "mine.about": "About",
  "mine.feedback": "Feedback",
  "mine.logout": "Logout",
  "mine.logoutAccount": "Delete Account",

  "mine.logoutAccountTips": "Delete account named []",
  "mine.logoutAccountTips1": "Delete account bound to []",
  "mine.logoutAccountCare": "Related matters for account deletion:",
  "mine.logoutAccountCare1": "1. Account is in secure state",
  "mine.logoutAccountCare1-1": "Account is currently in normal use, no risk of theft, violation, or suspension.",
  "mine.logoutAccountCare2": "2. Account authorization and binding relationships have been removed",
  "mine.logoutAccountCare2-1": "Account has been unlinked from other third-party platforms.",
  "mine.logoutAccountCare3": "3. Account cannot be recovered after deletion, all user data will be cleared",
  "mine.logoutAccountCare3-1": "After account deletion, bound phone, email and related data will be cleared and cannot be recovered.",
  "mine.confirmLogout": "Confirm Deletion",
  "mine.logoutSuccess": "Account deleted successfully!",


  "mine.feedbackIssues": "Feedback Issues",
  "mine.feedQuantity": "Quantity",
  "mine.feedAmount": "Up to 9 images, max 1MB each",

  "mine.notice.fail": "Failed to get notification settings!",
  "mine.notice.saveSuccess": "Notification settings saved successfully!",
  "mine.notice.saveFail": "Save failed!",
  "mine.notice.title": "Notification Settings",
  "mine.notice.batteryLow": "Low Battery Notification",
  "mine.notice.chargingFinish": "Charging Complete Notification",
  "mine.notice.error": "Error Notification",
  "mine.notice.update": "Update Notification",
  "mine.notice.monthly": "Monthly Statistics Notification",
  "mine.notice.receiveType": "Receive Method",

  "mine.language.welcome": "Welcome to SusprSafe",
  "mine.language.desc1": "Please set the language version according to your region",
  "mine.language.desc2": "You can change it anytime through the app settings",

  "mine.userInfo.avatar":"Avatar",
  "mine.userInfo.nickname":"Nickname",
  "mine.userInfo.password":"Password",
  "mine.userInfo.changePassword":"Change Password",
  "mine.userInfo.setPassword":"Set Password",
  "mine.userInfo.phoneNumber":"Phone Number",
  "mine.userInfo.bindPhone":"Bind Phone Number",
  "mine.userInfo.bindEmail":"Bind Email",
  "mine.loginExpired":"Login expired, please login again",
  "mine.userInfo.title":"User Information",
  "mine.userInfo.bind":"Bind",
  "mine.userInfo.modify": "Modify",
  "mine.userInfo.modifyNickname":"Change Nickname",
  "mine.userInfo.userNickname":"User Nickname",
  "mine.userInfo.selectPic":"Please select image to upload",
  "mine.userInfo.saveSuccess":"Saved successfully",
  "mine.userInfo.uploadFail":"Upload failed",
  "mine.userInfo.avatarSaveSuccess":"Avatar saved successfully",
  "mine.userInfo.nameTips1":"Nickname cannot be empty",
  "mine.userInfo.nameTips2":"Please enter nickname",

  "common.pleaseSelect": "Please Select",
  "question.commonQuestions": "Frequently Asked Questions",
  "account.toggleLanguage": 'Switch Language',
  "account.localConnection": "Local Connection",
  "account.selectLanguage": 'Please Select Language',
  "account.sendEmailToast": "The verification code has been sent to email xxx, please check your email",
  "account.emailError": "The email format is incorrect",
  "account.sendEmailFail": "Sending failed, please try again",

  "common.submitting": "Submitting, please wait...",
  "device.page.noData": "No data yet. This page can only be previewed in the app.",

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
  
};